import { confirmAlert } from 'react-confirm-alert';

import { ResetUserPasswordConfirmation } from './ResetUserPasswordConfirmation';

interface ConfirmResetUserPasswordProps {
  url: string;
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
}

function confirmResetUserPassword({
  url,
  onConfirm,
  onReject,
}: ConfirmResetUserPasswordProps): void {
  let isConfirmed = false;

  confirmAlert({
    customUI: ({ onClose }) => (
      <ResetUserPasswordConfirmation
        onClose={() => {
          isConfirmed = true;
          onConfirm();
          onClose();
        }}
        url={url}
      />
    ),
    willUnmount: () => {
      if (!isConfirmed) {
        onReject?.();
      }
    },
  });
}

export { confirmResetUserPassword };
